const ACTIVITY_PLACE_TYPES = {
  STANDARD: 'STANDARD',
  AMBULATORY: 'AMBULATORY',
  SEA: 'SEA',
  TRANSPORT_PUBLIC_VIA: 'TRANSPORT_PUBLIC_VIA',
  PUBLIC_VIA: 'PUBLIC_VIA',
  OWN_ADDRESS: 'OWN_ADDRESS',
  CUSTOMER_ADDRESS: 'CUSTOMER_ADDRESS',
  LEASE_SPACE_AREA: 'LEASE_SPACE_AREA',
  LEASE_ENABLED_AREA: 'LEASE_ENABLED_AREA',
  OTHER: 'OTHER',
};

const ACTIVITY_PLACE_TYPES_ENUM = Object.keys(ACTIVITY_PLACE_TYPES);

export {
  ACTIVITY_PLACE_TYPES, ACTIVITY_PLACE_TYPES_ENUM,
};
